import React from 'react';
import { LockIcon, HeartIcon, Share2Icon, UserIcon, ChevronLeftIcon, ChevronRightIcon, RotateCwIcon } from 'lucide-react';
import { brokerage, listing, agent, interiorPhotos } from '../../../data/reportPhilly';
// A clean recreation of the Berkshire Hathaway HomeServices Fox & Roach listing
// detail page, framed in a minimal browser window.
const navItems = ['FIND A HOME', 'SELL A HOME', 'COMMUNITIES', 'MARKET INSIGHTS', 'SERVICES', 'OUR STORY'];
const subNav = ['Overview', 'Facts & Features', 'Neighborhood', 'Mortgage', 'History', 'Nearby Properties'];
export function BrowserListing() {
  const listingUrl = `www.foxroach.com/realestate/details/${listing.address.toLowerCase().replace(/\s+/g, '-')}-${listing.city.toLowerCase()}-pa`;
  return <div className="mx-auto w-full max-w-3xl overflow-hidden rounded-lg border border-black/10 bg-white shadow-2xl" data-id="element-586" data-mp="22x3qrom82p9k">
      {/* --- minimal browser chrome: nav buttons + single URL bar --- */}
      <div className="flex items-center gap-3 border-b border-border bg-[#f1f1f2] px-4 py-2.5" data-id="element-587" data-mp="kn8f5wcecjs3">
        <div className="flex gap-1.5" data-id="element-588" data-mp="fpgrjeisbjtp">
          <span className="size-3 rounded-full bg-[#ff5f57]" data-id="element-589" data-mp="fqrrf39407fj" />
          <span className="size-3 rounded-full bg-[#febc2e]" data-id="element-590" data-mp="toygbtw2yx32" />
          <span className="size-3 rounded-full bg-[#28c840]" data-id="element-591" data-mp="tmdfn87iqn6w" />
        </div>
        <div className="ml-1 flex items-center gap-2.5 text-black/30" data-id="element-592" data-mp="plthc1b7ldj6">
          <ChevronLeftIcon className="size-4" data-id="element-593" data-mp="13lujrl74gt0r" />
          <ChevronRightIcon className="size-4" data-id="element-594" data-mp="13kjefgy13d7j" />
          <RotateCwIcon className="size-3.5" data-id="element-595" data-mp="ymrp8uorq571" />
        </div>
        <div className="flex flex-1 items-center gap-2 truncate rounded-md border border-black/10 bg-white px-3 py-1.5 text-xs text-black/60" data-id="element-596" data-mp="1dcpd19iscsvp">
          <LockIcon className="size-3 shrink-0" data-id="element-597" data-mp="18exdbtbwg2gy" />
          <span className="truncate" data-id="element-598" data-mp="1mddk1k9rhsz3">{listingUrl}</span>
        </div>
      </div>

      {/* --- listing page body --- */}
      <div className="bg-white text-[#2a2a2a]" data-id="element-599" data-mp="1hesr85wuabko">
        {/* brand header */}
        <div className="flex items-center justify-between px-6 pt-5" data-id="element-600" data-mp="f0uzsaujbwyf">
          <img src={brokerage.logoLight} alt={brokerage.name} className="h-10 w-auto object-contain object-left" data-id="element-601" data-mp="f2pj5kq5rh0e" />
          <div className="hidden items-center gap-3 sm:flex" data-id="element-602" data-mp="o1b1pfvmqw16">
            <UserIcon className="size-5 text-bhhs-cab" data-id="element-603" data-mp="ss9g29x25k1s" />
            <span className="bg-bhhs-cab px-3 py-1.5 text-[10px] font-semibold text-white" data-id="element-604" data-mp="stubs2v3z918">
              FINANCING OPTIONS
            </span>
          </div>
        </div>

        {/* primary nav */}
        <nav className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 border-b-2 border-bhhs-cab px-6 pb-2 text-[10px] font-semibold tracking-wide text-[#2a2a2a]" data-id="element-605" data-mp="12ow04whk872r">
          {navItems.map(n => <span key={n} data-id="element-606" data-mp="1bqltw8ywzi3p">{n}</span>)}
        </nav>

        {/* sub nav */}
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-border px-6 py-2.5" data-id="element-607" data-mp="39i880ubcv9v8">
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-[#4a4a4a]" data-id="element-608" data-mp="3dj0gvmgbfcqz">
            {subNav.map((s, i) => <span key={s} className={i === 0 ? 'font-semibold text-black' : ''} data-id="element-609" data-mp="360tzy5ks5ojy" data-mpi={i}>
                {s}
              </span>)}
          </div>
          <div className="flex items-center gap-3 text-[11px] text-bhhs-cab" data-id="element-610" data-mp="2wa7p0oo0dm7l">
            <span className="inline-flex items-center gap-1" data-id="element-611" data-mp="2s84a1q24rzhk">
              <HeartIcon className="size-3.5" data-id="element-612" data-mp="2s5rkoru1mmuh" /> Save
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-613" data-mp="3oxbnsbwid4ax">
              <Share2Icon className="size-3.5" data-id="element-614" data-mp="3jy8v7qxpsqju" /> Share
            </span>
          </div>
        </div>

        {/* photo grid */}
        <div className="grid grid-cols-1 gap-1.5 p-3 sm:grid-cols-[2fr_1fr]" data-id="element-615" data-mp="3fvu7otj3p2m8">
          <div className="relative" data-id="element-616" data-mp="3ayvgojuqhbs9">
            <span className="absolute left-2 top-2 bg-white px-2 py-0.5 text-[10px] font-bold tracking-wide text-[#2a2a2a] shadow" data-id="element-617" data-mp="3axsswkspjpgk">
              NEW
            </span>
            <img src={listing.heroImage} alt={listing.address} className="h-48 w-full object-cover sm:h-64" data-id="element-618" data-mp="1zhvpjrk4h2zt" />
          </div>
          <div className="grid grid-cols-3 gap-1.5 sm:grid-cols-1" data-id="element-619" data-mp="3s6v47feub8qc">
            {interiorPhotos.map((src, i) => <div key={src} className="relative" data-id="element-620" data-mp="3efydju4h51lx" data-mpi={i}>
                <img src={src} alt="" className="h-16 w-full object-cover sm:h-[4.9rem]" data-id="element-621" data-mp="3ed3sq1hjterz" />
                {i === interiorPhotos.length - 1 && <div className="absolute inset-0 flex items-center justify-center bg-black/45" data-id="element-622" data-mp="ezjj82ja1ejk">
                    <span className="text-center text-[9px] font-semibold text-white" data-id="element-623" data-mp="10afi2c9ccwh">
                      SEE ALL
                      <br data-id="element-624" data-mp="5yc0ist8umal" />
                      67 PHOTOS
                    </span>
                  </div>}
              </div>)}
          </div>
        </div>

        {/* summary row */}
        <div className="flex flex-col gap-4 px-6 pb-6 sm:flex-row sm:items-start sm:justify-between" data-id="element-625" data-mp="2qq40pck5nd1o">
          <div data-id="element-626" data-mp="2i70o7r0v4cba">
            <h3 className="text-xl font-bold uppercase tracking-tight text-[#1a1a1a]" data-id="element-627" data-mp="2i6ilcbjp2zue">
              {listing.address}
            </h3>
            <p className="text-sm font-medium uppercase text-[#4a4a4a]" data-id="element-628" data-mp="2s6hwmg7i14ay">
              {listing.cityState}
            </p>
            <p className="mt-1.5 text-xs text-[#6a6a6a]" data-id="element-629" data-mp="2n7571np8tj4o">
              Single Family · {listing.beds} Beds · {listing.baths} Baths ·{' '}
              {listing.sqft} Sq. ft.
            </p>
          </div>
          <div className="sm:text-right" data-id="element-630" data-mp="1ujsl9fqwpfcf">
            <p className="text-2xl font-bold text-[#1a1a1a]" data-id="element-631" data-mp="1ugoau0mulndb">{listing.price}</p>
            <p className="mt-0.5 text-[11px] font-medium text-bhhs-cab underline" data-id="element-632" data-mp="29988ilr8b2nd">
              est. mortgage available*
            </p>
            <div className="mt-3 flex gap-2 sm:justify-end" data-id="element-633" data-mp="1grcnougry9iw">
              <span className="bg-bhhs-cab px-3 py-2 text-[10px] font-semibold text-white" data-id="element-634" data-mp="1gprrl0etaiix">
                SCHEDULE SHOWING
              </span>
              <span className="border border-bhhs-cab px-3 py-2 text-[10px] font-semibold text-bhhs-cab" data-id="element-635" data-mp="3bur5ipjurb52">
                REQUEST INFO
              </span>
            </div>
          </div>
        </div>

        {/* agent strip */}
        <div className="flex items-center gap-3 border-t border-border bg-[#faf7f8] px-6 py-3" data-id="element-636" data-mp="3lldhm9sd1jj0">
          <img src={agent.avatar} alt={agent.name} className="size-9 rounded-full object-cover" data-id="element-637" data-mp="3pkup18rckqqt" />
          <div className="leading-tight" data-id="element-638" data-mp="2sxpxswywywxf">
            <p className="text-xs font-semibold text-bhhs-cab" data-id="element-639" data-mp="2xtybe5xgqi2h">
              {agent.name}, REALTORS®
            </p>
            <p className="text-[10px] text-[#6a6a6a]" data-id="element-640" data-mp="31vjvoccbtymp">
              {agent.brokerage} · {agent.phone}
            </p>
          </div>
        </div>
      </div>
    </div>;
}